import React, { useContext } from "react";
import { SurveyContext } from "../../store/survey-context";
import MacallanAPI from "../../api/macallan";
import { calculateTotalProgress } from "../../utils";
import { useTranslation } from "react-i18next";

export default function MarkForLater() {
  const context = useContext(SurveyContext);
  const { t } = useTranslation(["common"]);
  const { survey, markedForLater, userProfile, setAccessToken } = context;

  // Don't show the button if:
  // - page already has an answer
  // - we're on "Easter egg"
  // - Mark for later is disabled in survey-questions.js (disabledMarkForLater)

  function markPageForLater() {
    // clear curren answers
    context.survey.currentPage.questions.forEach(function (q) {
      q.value = null;
    });
    context.survey.currentPage.isMarkedForLater = true;
    context.addMarkedForLater(context.survey.currentPage.crmId);
    context.markedForLater.push(context.survey.currentPage.crmId);
    const marked = [...new Set(context.markedForLater)];

    if (context.accessToken) {
      const overallPercentageComplete = calculateTotalProgress(context.survey);
      const api = new MacallanAPI(context.accessToken);
      api
        .setMarkedForLater({ overallPercentageComplete }, marked)
        .catch((e) => {
          context.setError(true);
          console.log(e);
        })
        .finally(() => {
          if (api.accessToken !== context.accessToken)
            setAccessToken(api.accessToken);
        });
    }
    context.survey.ignoreValidation = true;
    context.survey.nextPage();
    context.survey.ignoreValidation = false;
  }

  const isAnswered =
    userProfile.answers &&
    typeof userProfile?.answers[survey?.currentPage.crmId] !== "undefined";
  if (
    isAnswered ||
    survey?.currentPage.isEasterEgg ||
    survey?.currentPage.disabledMarkForLater
  )
    return null;

  const isMarkedForLater =
    markedForLater.indexOf(survey?.currentPage.crmId) !== -1;

  const activeClass = isMarkedForLater ? "sv-mfl--active" : "";
  const btnText = isMarkedForLater
    ? `${t("button.marked_later_line1")} ${t("button.marked_later_line2")}`
    : `${t("button.mark_question_line1")} ${t("button.mark_question_line2")}`;

  return (
    <button
      className={`sv-mfl ${activeClass}`}
      onClick={() => markPageForLater()}
    >
      <div className="icon">
        <svg
          width="11"
          height="17"
          viewBox="0 0 11 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.11917 10.2112L0.5 15.6407V0.5H10.5V15.6407L5.88083 10.2112L5.5 9.76359L5.11917 10.2112Z"
            stroke="white"
          />
        </svg>
      </div>
      <span>{btnText}</span>
    </button>
  );
}
